import React from 'react';
import clsx from 'clsx';
import { ImageAndExpandableListV2 } from 'types/studio/studio';
import { Typography, getTypographyDefaultColor } from '@ag1/ui';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { StudioBaseIconV2 } from 'shared/studio/StudioBaseIcon/StudioBaseIcon';
import styles from './TableSection.module.scss';

type Props = {
  tableOptions: ImageAndExpandableListV2['tableOptions'];
  theme: ImageAndExpandableListV2['theme'];
  insideList?: boolean;
};

const TableSection = ({ tableOptions, theme, insideList }: Props) => {
  const { addTable, table } = tableOptions || {};

  if (!addTable || !Array.isArray(table) || table.length === 0) {
    return null;
  }

  return (
    <div className={clsx(styles.root, insideList && styles.insideList)}>
      {table?.map((item) => (
        <div key={item._key} className={styles.item}>
          {item.badge?.asset && (
            <StudioBaseIconV2 key={item._key} icon={item.badge} className={styles.badge} />
          )}
          <Typography
            component="div"
            variant="body"
            size={insideList ? '2' : '1'}
            noPadding
            color={getTypographyDefaultColor(theme)}>
            <CustomPortableText value={item.text} className={styles.text} />
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default TableSection;
